import { render, staticRenderFns } from "./FaqShow.vue?vue&type=template&id=0181f2cc&"
import script from "./FaqShow.vue?vue&type=script&lang=js&"
export * from "./FaqShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports